export const WORK_APPROVAL_MODES = [
  { id: 'ask', label: 'Ask first', icon: 'hand', description: 'Check with me before using the internet, changing files, or taking actions in apps.' },
  { id: 'smart', label: 'Smart approval', icon: 'shield-halved', description: 'Research, edit files, run checks, and navigate apps automatically. Ask before consequential or unrecognized actions.' },
  { id: 'full', label: 'Hands-off', icon: 'triangle-exclamation', description: 'Carry out actions without approval prompts using this task’s connected access.' },
];

export const workApprovalMode = value => WORK_APPROVAL_MODES.find(mode => mode.id === value) || WORK_APPROVAL_MODES[1];
